// CANONICAL COPY (GH #7115). src/constants/obligations/obl-transparency-notices.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-transparency-notices',
  title: 'Verify transparency information and privacy notices',
  description:
    'Confirm that data subjects are provided with the transparency information required under GDPR Articles 12–14 in a concise, transparent, intelligible and easily accessible form — whether personal data is collected directly from the data subject (Art. 13) or obtained from another source (Art. 14). Privacy notices shall state the identity of the controller, the purposes and lawful basis of processing, recipients, retention periods, data subject rights and, where applicable, the source of the data, and shall be published wherever personal data is collected. Review the privacy notice(s) for currency and completeness.',
  category: 'compliance',
  scfIds: ['SCF-PRV-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Privacy notice / transparency statement is published',
    },
    { type: 'document-approved', description: 'Privacy notice has been approved' },
    { type: 'document-within-sla', description: 'Privacy notice review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
